<template>
  <div class="classTableDiv">
    <el-table
      :data="list"
      border
      fit
      :height="options.tableHeight"
      style="width: 100%"
      @row-click="openDetails"
      @selection-change="handleSelectionChange"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="no-data">
          <i class="crm-wu"></i>
          <span class="text-1">{{options.errortip}}</span>
        </div>
      </template>
      <!--region 选择框-->
      <el-table-column v-if="options.mutiSelect" type="selection" style="width: 55px;"></el-table-column>
      <!--endregion-->
      <!-- 编辑列start -->
      <template v-for="(column,$index) in columns">
        <template v-if="column.isfixed ">
          <el-table-column
            :prop="column.fieldstring"
            :key="$index"
            :fixed="column.fixed"
            :label="column.fieldname"
            :align="column.align"
            min-width="150px"
            v-if="column.isShow ||column.show=='1'"
          >
            <template slot-scope="scope">
              <el-button
                v-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index,scope.row)"
              >{{list[scope.$index][column.fieldstring]}}</el-button>
              <span v-else type="text">{{list[scope.$index][column.fieldstring]}}</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            :prop="column.fieldstring"
            :key="$index"
            :label="column.fieldname"
            align="center"
            min-width="150px"
            v-if="column.show=='1'"
          >
            <!-- 判断意向星级 -->
            <!-- 判断二维码 -->
            <template slot-scope="scope">
              <div v-if="column.is_percentage=='1'" class="progress">
                <el-progress
                  :percentage="list[scope.$index][column.fieldstring].percentage"
                  :show-text="false"
                ></el-progress>
                <span>{{list[scope.$index][column.fieldstring].study_num}}/{{list[scope.$index][column.fieldstring].class_fullnums}}</span>
              </div>
              <span v-else>{{list[scope.$index][column.fieldstring]}}</span>
              <!-- <div v-if="column.iscode" class="table-code" @click="handleCodeChange(scope.$index,scope.row)">
                            <img :src="list[scope.$index][column.prop]">
              </div>
              <p v-else-if="!column.islevel">{{list[scope.$index][column.prop]}}</p>-->
              <!-- 判断意向星级 -->
              <!-- <span v-else><i v-for="n in list[scope.$index][column.prop]" :key="n" class="icon-heart-off"></i></span> -->
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 编辑列end -->
      <!--region 按钮操作组-->
      <el-table-column
        ref="fixedColumn"
        :label="operates.label"
        :align="operates.align"
        :width="operates.width"
        :fixed="operates.fixed"
        v-if="operates.list.filter(_x=>_x.show === true).length > 0"
      >
        <template slot-scope="scope">
          <template v-for="(btn, key) in operates.list">
            <div class="item" v-if="btn.show &&scope.row.is_visit_autition" :key="btn.id">
              <el-button
                @click.native.prevent="btn.method(key,scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition=='1'"
              ></el-button>
              <el-button
                @click.native.prevent="btn.method(key,scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition=='0'"
              >{{ btn.label }}</el-button>
              <el-button
                @click.native.prevent="btn.method(key,scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition=='-1'"
              ></el-button>
            </div>
            <div class="item" v-else-if="btn.show" :key="btn.id">
              <el-button
                @click.native.prevent="btn.method(key,scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
              >{{ btn.label }}</el-button>
            </div>
          </template>
        </template>
      </el-table-column>

      <!-- 自定义列 -->
      <el-table-column
        v-if="issetting"
        :fixed="tableOperate.fixed"
        :label="tableOperate.label"
        :align="tableOperate.align"
        width="40px"
        :render-header="renderHeader"
      >
        <!-- <template slot-scope="scope"></template> -->
      </el-table-column>
    </el-table>
    <!-- {{total.dataNumber}} -->
    <!-- 分页 -->
    <!-- <el-pagination
      v-if="isPagination"
      style="margin-top: 35px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="8"
    ></el-pagination>-->
  </div>
</template>

<script>
export default {
  name: "classTable",
  props: {
    total: Number, //分页数据
    pagesize: Number, //分页条数
    issetting: null, //是否可编辑列
    list: {
      type: Array
      // default: []
    }, // 数据列表
    isCheckbox: null,
    isPagination: null,
    columns: {
      type: Array
      // default: []
    }, // 需要展示的列 === prop：列数据对应的属性，label：列名，align：对齐方式，width：列宽
    operates: {}, // 操作按钮组 === label: 文本，type :类型（primary / success / warning / danger / info / text），show：是否显示，icon：按钮图标，plain：是否朴素按钮，disabled：是否禁用，method：回调方法
    options: {
      type: Object
      // default: {
      //   highlightCurrentRow: false // 是否要高亮当前行
      // }
    }, // table 表格的控制参数
    tableOperate: {
      type: Object
    }
  },
  data() {
    return {
      currentPage: 1,
      num: 10,
      size: 10,
      tableHeight: Number
    };
  },
  created() {
    
    this.num = this.total;
    this.size = this.pagesize;
    this.tableHeight = parseInt(this.getClientHeight());
  },
  watch: {
    total(newdata, olddata) {
      (() => {})(newdata, olddata);
      this.num = this.newdata;
    },
    pagesize(newdata, olddata) {
      (() => {})(newdata, olddata);
      this.size = this.newdata;
    }
  },
  computed: {},
  methods: {
    // 获取窗口高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        var clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      } else {
        var clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      }
      return clientHeight - 400;
    },
    // 点击表格
    openDetails(row, event, column) {
      (() => {})(row);
      this.$emit("openDetails", row);
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.$emit("handleSelectionChange", val);
    },
    handleColumnChange(k, v) {
      (() => {})(k, v);
      this.$emit("handleColumnChange", k, v);
    },
    handleCodeChange(k, v) {
      (() => {})(k, v);
      this.$emit("handleCodeChange", k, v);
    },
    renderHeader(h, { column, $index }) {
      (() => {})(h, column, $index);
      return h("span", {
        class: "el-icon-setting",
        on: {
          click: () => {
            (() => {})(`${column.label}----${$index}`);
            this.$emit("toggleEditableColumn");
          }
        }
      });
    }
    // 分页
    // handleSizeChange(val) {
    //   (() => {})(`每页 ${val} 条`);
    //   (() => {})(this.total.dataNumber);
    // },
    // handleCurrentChange(val) {
    //   (() => {})(`当前页: ${val}`);
    // }
  }
};
</script>

<style lang="less">
.item {
  display: inline-block;
}

.item + .item {
  margin-left: 15px !important;
}

.link-type {
  font-weight: normal;
}

.table-code {
  width: 40px;
  margin: 0 auto;

  img {
    width: 100%;
  }
}

.el-icon-setting {
  display: block;
  width: 20px;
  height: 20px;
  font-size: 18px;
  margin: 0 auto;
  color: #aaa;
  // background-color: green;
  cursor: pointer;
}
</style>
